import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export default ({ crumbs }) => (
  <Breadcrumb>
    {crumbs.map(({ path, name }) => (
      <BreadcrumbLink key={path}>
        <Link to={path} replace>{name}</Link>
      </BreadcrumbLink>
    ))}
  </Breadcrumb>
);

const BreadcrumbContainer = styled.div`
  padding: 1.125rem 0;
  border-bottom: 1px solid rgba(0,0,0,.25);
`;

const BreadcrumbInner = styled.div`
  max-width: 59.5rem;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
`;

const Breadcrumb = ({ children, ...props }) => {
  return (
    <BreadcrumbContainer {...props}>
      <BreadcrumbInner>{children}</BreadcrumbInner>
    </BreadcrumbContainer>
  )
};

const BreadcrumbLink = styled.span`

  &:after {
    content: " / ";
  }

  &:last-child:after {
    content: initial;
  }

  a {
    font-size: .9375rem;
    color: #222222;
    border-bottom: 1px solid transparent;
  }

  &:last-child a {
    border-bottom-color: #000;
    font-weight: bolder;
    color: #000;
  }
`;
